import MessageAdditionalsChangePassword       from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsChangePassword.vue'
import MessageAdditionalsLogoutConfirmation   from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsLogoutConfirmation.vue'
import MessageAdditionalsTaggedInfomation     from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsTaggedInfomation.vue'
import MessageAdditionalsLeaveConfirmation    from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsLeaveConfirmation.vue'
import MessageAdditionalsChangeName           from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsChangeName.vue'
import MessageAdditionalsChangeEmail          from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsChangeEmail.vue'
import MessageAdditionalsChangeThumbnail      from '@/components/Pages/Office/MessageApp/Additionals/ChangeThumbnail/ChangeThumbnail.vue'
import MessageAdditionalsShowThumbnail        from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsShowThumbnail.vue'
import MessageAdditionalsRegistNumber         from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsRegistNumber.vue'
import MessageAdditionalsNotification         from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsNotification.vue'
import MessageAdditionalsCreateNewPark        from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsCreateNewPark.vue'
import MessageAdditionalsRegistParkInvitation from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsRegistParkInvitation.vue'

import MessageAdditionalsModalNotification  from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsModalNotification.vue'

import MessageAdditionalsCheckApplicationStatus from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsCheckApplicationStatus/MessageAdditionalsCheckApplicationStatus.vue'

import MessageAdditionalsStartTutorial from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsStartTutorial.vue'

import MessageAdditionalsQuestion from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsQuestion/MessageAdditionalsQuestion.vue'

import {ChangeDisplayName, ChangePassword, ChangeEmail}  from '@/graphql/mutations/User.graphql'
import {ChangeThumbnail} from '@/graphql/mutations/Character.graphql'
import {GetMe, GetUserMeta}  from '@/graphql/queries/User.graphql'

import {GetCharacterMeta} from '@/graphql/queries/Character.graphql'

import {UpdateCharacterMeta} from '@/graphql/mutations/Character.graphql'

import {RegistSerialNumber} from '@/graphql/mutations/Character.graphql'
import {UpdateUserMeta}     from '@/graphql/mutations/User.graphql'

import {CreateNewPark, RegistParkInvitationCode} from '@/graphql/mutations/Park.graphql'

import {SetAnswerCharacterQuestion} from '@/graphql/mutations/CharacterQuestion.graphql'

export default {
  components : {
    MessageAdditionalsLogoutConfirmation,
    MessageAdditionalsChangePassword,
    MessageAdditionalsTaggedInfomation,
    MessageAdditionalsLeaveConfirmation,
    MessageAdditionalsChangeName,
    MessageAdditionalsChangeEmail,
    MessageAdditionalsChangeThumbnail,
    MessageAdditionalsShowThumbnail,
    MessageAdditionalsRegistNumber,
    MessageAdditionalsNotification,
    MessageAdditionalsModalNotification,
    MessageAdditionalsCreateNewPark,
    MessageAdditionalsRegistParkInvitation,

    MessageAdditionalsCheckApplicationStatus,
    MessageAdditionalsStartTutorial,
    MessageAdditionalsQuestion
  },

  data(){
    return {
      additionalComponents : {
        'change-password'     : 'MessageAdditionalsChangePassword',
        'tagged-infomation'   : 'MessageAdditionalsTaggedInfomation',
        'logout'              : 'MessageAdditionalsLogoutConfirmation',
        'leave'               : 'MessageAdditionalsLeaveConfirmation',
        'change-name'         : 'MessageAdditionalsChangeName',
        'change-email'        : 'MessageAdditionalsChangeEmail',
        'change-thumbnail'    : 'MessageAdditionalsChangeThumbnail',
        'show-thumbnail'      : 'MessageAdditionalsShowThumbnail',
        'regist-number'       : 'MessageAdditionalsRegistNumber',
        'notification'        : 'MessageAdditionalsNotification',
        'create-new-park'     : 'MessageAdditionalsCreateNewPark',
        'modal-notification'  : 'MessageAdditionalsModalNotification',
        
        'check-application-status' : 'MessageAdditionalsCheckApplicationStatus',

        'start-tutorial'           : 'MessageAdditionalsStartTutorial',

        'question'                 : 'MessageAdditionalsQuestion',

        'regist-park-invitation'  : 'MessageAdditionalsRegistParkInvitation'
      },

      additionalControl   : {
        isDisabled  : false,
        isLoading   : false,
        serverError : null,
      }
    }
  },

  methods : {
    async handleAdditionalSubmit(formSet, options = {}){
      let isSucceed = false;

      switch(this.message.additionals){
        case 'change-name':
          isSucceed = await this.executeChangeName(formSet);
        break;

        case 'change-password':
          isSucceed = await this.executeChangePassword(formSet)
        break;

        case 'change-email':
          isSucceed = await this.executeChangeEmail(formSet);
        break;

        case 'regist-number':
          isSucceed = await this.executeRegistNumber(formSet);
        break;

        case 'change-thumbnail':
          isSucceed = await this.executeChangeThumbnail(formSet);
        break;

        case 'logout':
          await this.executeLogout();
        break;

        case 'start-tutorial':
          await this.executeStartTutorial(options);
        break;

        case 'leave':
          await this.executeLeave();
        break;

        case 'notification':
          switch(options.inProgressField){
            case 'mailNotification':
            case 'mailNewsLetter':
              await this.handleUpdateUserMeta(formSet, options);
            break;
            
            case 'pushNotification':
              await this.executeSetPushNotification();
            break;
          }
        break;

        case 'modal-notification':
          await this.handleUpdateUserMeta(formSet, options);
        break;

        case 'create-new-park':
          isSucceed = await this.executeCreateNewPark(formSet);
        break;

        case 'question':
          isSucceed = await this.executeAnswerQuestion(options);
        break;

        case 'regist-park-invitation':
          isSucceed = await this.executeRegistParkInvitation(formSet);
        break;

        // case 'test':
        //   this.additionalControl.isLoading = true;

        //   setTimeout(() => {
        //     this.additionalControl.isLoading = false;
        //     // this.$parent.$parent.$emit('hasCommandRequest', slug);
        //   }, 1000);
        // break;
      }

      if(isSucceed === true){
        this.$emit('handleAdditionalSubmit', {
          messageId       : this.message.id,
          additionalType  : this.message.additionals,
          data            : formSet,
          options         : options
        });
      }
    },

    async handleAdditionalCancel(payload){
      switch(this.message.additionals){
        default:
          // console.log('none');
        break;
      }

      this.$emit('handleAdditionalCancel', {
        additionalType  : this.message.additionals,
        data            : payload
      });
    },

    async handleClickAdditionalMenuButton(payload){
      this.additionalControl.isLoading = false;

      this.$parent.$parent.$emit('handleTagInfomationButtonClick', payload);
    },
    
    executeAnswerQuestion(options){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : SetAnswerCharacterQuestion,
          variables : {
            questionName  : options.questionName,
            value         : options.questionValue
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;
          
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          console.error(error);

          resolve(false);
        });
      });
    },

    executeCreateNewPark(formSet){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : CreateNewPark,
          variables : {
            name        : formSet.name.value,
            caption     : formSet.caption.value,
            description : formSet.description.value
          },
          // update    : (store, {data: {me}}) => {
          //   store.writeQuery({ query: GetMe, data : {
          //     me : me
          //   }});
          // }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;
          
          formSet.name.value        = '';
          formSet.caption.value     = '';
          formSet.description.value = '';
          
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          console.error(error);

          resolve(false);
        });
      });
    },

    executeChangeName(formSet){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : ChangeDisplayName,
          variables : {
            displayname : formSet.displayname.value,
          },
          update    : (store, {data: {me}}) => {
            store.writeQuery({ query: GetMe, data : {
              me : me
            }});
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;
          
          formSet.displayname.value = '';
          
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          console.error(error);

          resolve(false);
        });
      });
    },

    async executeChangePassword(formSet){
      this.additionalControl.isLoading = true;
      
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : ChangePassword,
          variables : {
            currentPassword : formSet.currentPassword.value,
            newPassword     : formSet.newPassword.value
          },
          update    : (store, {data: {me}}) => {
            store.writeQuery({ query: GetMe, data : {
              me : me
            }});
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          formSet.currentPassword.value = '';
          formSet.newPassword.value     = '';

          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },

    async executeChangeEmail(formSet){
      this.additionalControl.isLoading = true;
      
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : ChangeEmail,
          variables : {
            email : formSet.email.value,
          },
          update    : (store, {data: {me}}) => {
            store.writeQuery({ query: GetMe, data : {
              me : me
            }});
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          formSet.email.value = '';

          resolve(true);
        }).catch(async (error) => {
          await this.UXWaiting(500);

          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },

    async executeRegistNumber(formSet){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : RegistSerialNumber,
          variables : {
            serialNumber : formSet.serialNumber.value,
          },
          // numberの登録は一旦update無しにしておきます。
          // update    : (store, {data: {me}}) => {
          //   // store.writeQuery({ query: GetMe, data : {
          //   //   me : me
          //   // }});
          // }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          formSet.serialNumber.value = '';

          resolve(true);
        }).catch(async (error) => {
          await this.UXWaiting(500);

          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },

    async executeChangeThumbnail(base64Image){
      this.additionalControl.isLoading = true;
      
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : ChangeThumbnail,
          variables : {
            imageString : base64Image,
          },
          update    : (store, {data: {me}}) => {
            store.writeQuery({ query: GetMe, data : {
              me : me
            }});
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;
          
          resolve(true);
        }).catch(async (error) => {
          await this.UXWaiting(500);

          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },

    async executeLeave(){
      this.additionalControl.isLoading = true;

      await this.UXWaiting(1000);

      this.additionalControl.isLoading = false;

      this.$router.push({'name': 'leave'});
    },

    async executeLogout(){
      this.additionalControl.isLoading = true;

      await this.UXWaiting(1000);

      this.additionalControl.isLoading = false;

      this.$store.dispatch('systemLogout');
      
      Object.values(this.$apollo.provider.clients)
        .forEach(client => client.cache.reset());

      this.$router.push({'name': 'index'});
    },

    async executeStartTutorial(tutorialType){
      this.additionalControl.isLoading = true;

      await this.UXWaiting(1000);

      this.additionalControl.isLoading = false;

      switch(tutorialType){
        case 'start-full-tutorial':
          this.$store.dispatch({
            type  : 'tutorial/updateShouldOpenEntrance',
            value : true
          });
        break;

        case 'start-home-tutorial':
          this.$store.dispatch({
            type  : 'tutorial/updateTourType',
            value : 'single',
          });

          this.$store.dispatch({
            type  : 'tutorial/updateShouldOpenTour',
            name  : 'home'
          });
        break;

        case 'start-office-tutorial':
          this.$store.dispatch({
            type  : 'tutorial/updateTourType',
            value : 'single',
          });

          this.$store.dispatch({
            type  : 'tutorial/updateShouldOpenTour',
            name  : 'office'
          });
        break;

        case 'start-park-tutorial':
          this.$store.dispatch({
            type  : 'tutorial/updateTourType',
            value : 'single',
          });

          this.$store.dispatch({
            type  : 'tutorial/updateShouldOpenTour',
            name  : 'park'
          });
        break;

        case 'start-connection-tutorial':
          this.$store.dispatch({
            type  : 'tutorial/updateTourType',
            value : 'single',
          });

          this.$store.dispatch({
            type  : 'tutorial/updateShouldOpenTour',
            name  : 'connection'
          });
        break;
      }
    },

    async executeRegistParkInvitation(formSet){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : RegistParkInvitationCode,
          variables : {
            invitationCode : formSet.invitation_code.value,
          },
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          formSet.invitation_code.value = '';

          resolve(true);
        }).catch(async (error) => {
          await this.UXWaiting(500);

          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },


    async handleUpdateUserMeta(formSet, options){
      const updateData = {};

      const mutateDataSet = {
        'notifications.allowEmail'                          : 'mailNotification',
        'notifications.emailNewsLetter'                     : 'mailNewsLetter',
        'modalNotifications.isEnableCharacterLevelUpModal'  : 'isEnableCharacterLevelUpModal',
        'modalNotifications.isEnableGetItemModal'           : 'isEnableGetItemModal'
      };

      let updateField = '';
      for(let i in mutateDataSet){
        if(mutateDataSet[i] === options.inProgressField){
          updateField = i;
          break;
        }
      }

      updateData[updateField] = formSet[options.inProgressField].value;

      await this.executeUpdateUserMetaData(updateData);
    },

    executeUpdateUserMetaData(updateData){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateUserMeta,
          variables : {
            data : JSON.stringify(updateData),
          },
          update    : (store, {data: {userMetaList}}) => {
            store.writeQuery({ query: GetUserMeta, data : {
              userMetaList : userMetaList
            }});
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          resolve(true);
        }).catch(async (error) => {
          await this.UXWaiting(500);

          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },

    async handleUpdateCharacterMeta(formSet, options){
      const updateData = {};

      const mutateDataSet = {
        'parks.showEntrance'        : 'parksShowEntrance',
        'connections.showEntrance'  : 'connectionsShowEntrance'
      };

      let updateField = '';
      for(let i in mutateDataSet){
        if(mutateDataSet[i] === options.inProgressField){
          updateField = i;
          break;
        }
      }

      updateData[updateField] = formSet[options.inProgressField].value;

      await this.executeUpdateCharacterMetaData(updateData);
    },

    executeUpdateCharacterMetaData(updateData){
      this.additionalControl.isLoading = true;

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateCharacterMeta,
          variables : {
            data : JSON.stringify(updateData),
          },
          update    : (store, {data: {characterMetaList}}) => {
            const parameters = {
              query : GetCharacterMeta,
            };

            const readData = store.readQuery(parameters);

            readData.characterMetaList = characterMetaList;

            parameters.data = readData;

            store.writeQuery(parameters);
          }
        }).then(async () => {
          await this.UXWaiting(500);

          this.additionalControl.isLoading = false;

          resolve(true);
        }).catch(async (error) => {
          await this.UXWaiting(500);

          const errorSet = this.getApolloRequestErrorSet(error);
          
          this.additionalControl.serverError = errorSet;

          this.additionalControl.isLoading = false;

          resolve(false);
        });
      });
    },

    async executeSetPushNotification(){
      this.additionalControl.isLoading = true;

      await this.UXWaiting(500);

      const token = await this.getPushNotificationToken();
      
      if(token !== false){
        await this.executeUpdatePushNotification(token);
        
        // console.log(token);
      }else{
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;すでに拒否設定されている可能性があります。ブラウザの設定より許可してください。',
          status      : 'error',
          hasControl  : true,
          autoClose   : 8000
        }, {root:true});
      }

      this.additionalControl.isLoading = false;
    },

    getPushNotificationToken(){
      return new Promise((resolve) => {
        if(this.$firebaseMessaging === null){
          resolve(false);
        }else{
          this.$firebaseMessaging.getToken().then((currentToken) => {
            if (currentToken) {
              resolve(currentToken);
            } else {
              // console.log('No Instance ID token available. Request permission to generate one.');
  
              resolve(false);
            }
          }).catch(() => {
            // console.log('An error occurred while retrieving token. ', err);
  
            resolve(false);
          });
        }
      });
    },

    async executeUpdatePushNotification(token){
      this.additionalControl.isLoading = true;

      const data = {
        'notifications.token.web'  : token
      };

      return await this.executeUpdateUserMetaData(data);
    }
  },
}